(function($) {

	'use strict';
    
    var recaptchaInitLimit = 3000;
	
	/* RECAPTCHA UTIL FUNCTION */
	/**
	 * Render recaptchas dynamically.
	 * @param   btn         An element referencing the button or a string 
	 *                      referencing the Id of the element.
	 * @param   callback    A function to be called after recaptcha has 
	 *                      completed its check. The function is passed back
	 *                      the recaptcha response and the form element.
	 * @param   validate    (optional) A boolean to know if a form needs to be 
	 *                      validated using the formValidator in com/form.js.
	 * @param   form        (optional) A jQuery object reference the form to be
	 *                      validated using formValidator in com/form.js.
	 */
	
	var recaptcha = function(btn, fn, validate, form) {
        if (!btn || --recaptchaInitLimit <= 0) {
            return;
        }
        
		if(!!window.grecaptcha) {
			if (window.grecaptcha.render) {
				grecaptcha.render(btn, {
					'sitekey' : $(btn).attr('data-id'),
					'callback' : function(response) {
						var formValidator = Fw.component.models().form.validateForm;
						var validated = true;
						if(validate) {
							validated = false;	
							formValidator(form);
							if(!form.hasClass('has-error')) {
								validated = true;
							}
						}
						
						if(validated) {
							fn(response, form, btn);
						} else {
							grecaptcha.reset();
						}
					}
				});
			} else {
				setTimeout(function() {
					recaptcha(btn, fn, validate, form);
				}, 250);
			}
		} else {
			setTimeout(function() {
				recaptcha(btn, fn, validate, form);
			}, 250);
		}
	};
    
	var recaptcha2 = function (btn, callback) {
        var key = btn.getAttribute("data-id");
        if (!btn || !key || --recaptchaInitLimit <= 0) {
            // Captcha is not loaded, then bind click event on the functino as fallback
            if (btn && !$(btn).hasClass('get-stripe-token') && !$(btn).hasClass('get-worldPay-token')) {
                $(btn).on('click', callback);
            }
            return;
        }
        if (!!window.grecaptcha && !!grecaptcha.render) {
            var div = $('<div class="recaptcha-ctn"></div>').insertBefore(btn);
            var widgetId = grecaptcha.render(div[0], {
                'sitekey': key,
                'callback': function (response) {
                    callback.call(btn, response);
                },
                'badge': 'inline',
                'size': 'invisible'
            });
            btn.setAttribute('data-widget-id', widgetId);
            // Flow of validation: stripe token -> recaptcha -> form validation -> submit
            if (!$(btn).hasClass('get-stripe-token') && !$(btn).hasClass('get-worldPay-token')) {
                $(btn).on('click', function(e) {
                    grecaptcha.execute(widgetId);
                });
            }
        } else {
            setTimeout(function () {
                recaptcha2(btn, callback);
            }, 250);
        }
    };

	Fw.component.export('utils', {
		recaptcha: recaptcha,
        recaptcha2: recaptcha2
	});

})(jQuery);
